import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { Vue } from 'vue-property-decorator';
import tWidgetLibrary from '@/types/Dashboard/WidgetLibrary';
import Dictionary from "@/types/Dictionary";
import axios from "axios";
import { API_URL } from "@/App.settings";
import DashboardTypeEnum from "@/enums/DashboardTypeEnum";

/** Module Vuex de persistence de la bibliothèque de widgets commune au MainDashboard et ObjectDashboard */
@Module({
	namespaced: true
})
class WidgetLibraryStore extends VuexModule {
//#region Data
	private widgetsLibrary: tWidgetLibrary[] = [];
//#endregion Data
//#region Mutations
	/** Réinitialisation du store VueX */
	@Mutation
	private reset() {
		this.widgetsLibrary = [];
	}

	/** Chargement de la bibliothèque de widgets */
	@Mutation
	private loadData(data) {
		this.widgetsLibrary = data;
	}
//#endregion Mutations
//#region Actions
	/** Chargement de la bibliothèque de widgets */
	@Action({ rawError: true })
	public async LoadData() {
		const args: Dictionary<any> = {};
		args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
		// args["DashboardType"] = this.DashboardType;
		await axios.post(API_URL + "Dashboard/GetWidgetsLibrary", args).then((response) => {
			if (response && response.data)
				this.context.commit("loadData", response.data);
		});
	}

	/** Réinitialisation du store VueX */
	@Action({ rawError: true })
	public Reset() {
		this.context.commit("reset");
	}
//#endregion Actions
//#region Getters
	/** 
	 * Renvoi la bibliothèque de widgets associé à un type de tableau de bord
	 * @param dashboardType Type de tableau de bord dont les widgets sont à retourner
	 * @param objectType Filtre par type d'objet
	 * @returns Liste de widgets
	 *  */
	public get GetWidgetsLibrary() {
		return (dashboardType: DashboardTypeEnum, objectType: string = undefined): tWidgetLibrary[] => {
			let filteredWidgets: tWidgetLibrary[] = this.widgetsLibrary.filter(x => x.TargetDashboards.includes(dashboardType));
			console.debug("WidgetLibraryStore - GetWidgetsLibrary() - filteredWidgets : ", filteredWidgets);

			/** Filtre par type d'objet */
			if (objectType)
				filteredWidgets =  filteredWidgets.filter(x => !(x.TargetObjectTypes) || (x.TargetObjectTypes && ((x.TargetObjectTypes.length == 0) || x.TargetObjectTypes.length > 0 && x.TargetObjectTypes.includes(objectType))));

			return filteredWidgets;
		}
	}

	/** 
	 * Renvoi l'icone FontAwesome associé à un type de widget
	 * @param widgetType Type de widget dont on souhaite obtenir l'icone
	 * @returns Nom de l'icone FontAwesome associé à un widget
	 * @see https://fontawesome.com/search?m=free&o=r pour obtenir la liste des icones disponibles
	 *  */
	public get GetWidgetLibrary() {
		return (widgetType: string): tWidgetLibrary => {
			let widgetLibrary: tWidgetLibrary = this.widgetsLibrary.find(x => x.Name == widgetType)
			return widgetLibrary;
		}
	}

	/**
	 * Renvoi les types d'objet ciblés par un type de widget
	 * @param widgetType Type de widget dont on souhaite obtenir l'icone
	 * @returns Tableau d'ObjectTypeEnum sous forme de string
	 */
	public get GetWidgetObjectTypes() {
		return (widgetType: string): string[] => {
			return getWidgetProperty(this.widgetsLibrary, widgetType,'TargetObjectTypes');
		}
	}

	/** 
	 * Renvoi la liste des fonctions disponibles pour un widget 
	 * @param widgetType Type de widget dont on souhaite obtenir l'icone
	 * @returns Tableau de string
	 * */
	public get GetWidgetTargetFeatures() {
		return (widgetType: string): string[] => {
			return getWidgetProperty(this.widgetsLibrary, widgetType,'TargetFeatures');
		}			
	}

	/** 
	 * Renvoi la liste des fonctions disponibles pour un widget 
	 * @param widgetType Type de widget dont on souhaite obtenir l'icone
	 * @returns Tableau de string
	 * */
	public get GetWidgetExportableFeatures() {
		return (widgetType: string): string[] => {
			return getWidgetProperty(this.widgetsLibrary, widgetType,'ExportableFeatures');
		}			
	}
//#endregion Getters
}

/** Obtient la valeur tableau d'une propriété
 * @param widgetsLibrary	Liste des types de widgets
 * @param widgetType		Type de widget
 * @param property			Propriété à récupérer
 * @returns					Un tableau
 */
function getWidgetProperty(widgetsLibrary: tWidgetLibrary[], widgetType: string, property: string): [] {
	let widgetLibrary: tWidgetLibrary = widgetsLibrary.find(x => x.Name == widgetType)
	if (widgetLibrary)
		return widgetLibrary[property];
	else
		return [];		
}

export default WidgetLibraryStore;